type Props = {
  title?: string
  duration: string
}

export default function PlaylistCardInfo({
  title = "",
  duration,
}: Props) {
  return (
    <div
      className="
        flex
        w-full
        min-w-0
        items-end
        justify-between
        gap-1 //bg-white
      "
    >
      {/* TÍTULO */}
      <div>
        <p
          className="
            min-w-0
            flex-1
            truncate
            text-left
            text-[.48rem] md:text-[.65rem]
            font-semibold
            leading-none
            tracking-tight
            text-white
            //drop-shadow-[0_1px_3px_rgba(255,255,255,.9)]

            border-t border-b border-[var(--primary)]/35
            bg-[var(--color-sombra)] p-[.3rem] px-2 rounded-md
          ">
          {title}
        </p>
      </div>

      {/* DURACIÓN */}
      <span
        className="
          shrink-0
          whitespace-nowrap
          text-right
          text-[.48rem] md:text-[.65rem]
          font-medium
          leading-none
          text-white/85
          //drop-shadow-[0_1px_3px_rgba(255,255,255,.9)]

          border-t border-b border-[var(--primary)]/35
          bg-[var(--color-sombra)] p-[.3rem] px-2 rounded-md
        "
      >
        {duration}
      </span>
    </div>
  )
}